// const API_ENDPOINT = "https://certifications.sunspec.org/api/v1/products/";

const API_ENDPOINT = "/api/v1/products";

export default {
  API_ENDPOINT: API_ENDPOINT
};
